    <template>
        <v-list
            two-line
            subheader
            class="overflow-y-auto"
            style="border-radius: 0;"
            height="70vh"
        >
            <v-list-item-group
                v-model="selected"
                active-class="chosen-message"
                class="pb-16 pb-lg-3"
            >
                <template v-for="contact in contacts">
                    <v-list-item
                        :key="contact.name"
                        @click="selectContact(contact)"
                    >
                        <template v-slot:default="{ active, toggle }">
                            <v-list-item-avatar color="white" size="55">
                                <v-img
                                    v-if="contact.name != 'other'"
                                    alt="sender avatar image"
                                    max-height="50"
                                    max-width="50"
                                    :src="getBrandIconPath(contact.name)"
                                />
                                <v-icon
                                    v-else
                                    color="#00000066"
                                >
                                    mdi-account-outline
                                </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content
                                :class="active ? 'white--text' : ''"
                            >
                                <!-- list title -->
                                <v-list-item-title v-if="onSearch">
                                    <text-highlight :queries="[search]">
                                        {{ contact.name }}
                                    </text-highlight>
                                </v-list-item-title>
                                <v-list-item-title
                                    v-else
                                    v-text="contact.name"
                                />

                                <!-- list subtitle -->
                                <v-list-item-subtitle v-if="onSearch" :class="active ? 'white--text' : ''">
                                    <text-highlight :queries="[search]">
                                        {{ contact.email }}
                                    </text-highlight>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-else :class="active ? 'white--text' : ''">
                                    {{ contact.email }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-divider
                                vertical
                                light
                                class="ml-auto mr-n4"
                                :style="active ? 'border-width: 0 thin 0 0;' : 'border-width: 0 0 0 0;'"
                                color="#304FFE"
                            />
                        </template>
                    </v-list-item>
                    <v-divider light :key="contact.name+'b'" />
                </template>
            </v-list-item-group>
            <slot />
        </v-list>
</template>

<script>
    export default {
        props: {
            // eslint-disable-next-line vue/require-default-prop
            selectedEmail: Object,
            search: {
                required: false,
                default: '',
                type: String,
            },
            onSearch: Boolean,
            contacts: Array,
        },
        data() {
            return {
                selected: [],
            };
        },
        methods: {
            selectContact(contact) {
                const { kaoshi_email } = this.$store.state.user;
                this.$emit('select-contact', {
                    id: 'new',
                    contact,
                    subject: '',
                    body: '',
                    body_cleaned: '',
                    from_name: contact.name,
                    from_email: contact.email,
                    to_email: kaoshi_email,
                    text_html: '',
                    text_plain: '',
                    full_json: {
                        to: [
                            ['', kaoshi_email]
                        ],
                        body: '',
                        date: new Date().toISOString(),
                        from: [
                            [contact.name, contact.email]
                        ],
                    },
                    images: [],
                    image_keywords: [],
                    is_read: true,
                    urls: {},
                    index: 0,
                });
            }
        }
    };
</script>

<style scoped>
.chosen-message {
    background-color: #3f51b5;
}

/* .chosen-message .v-list-item__title,
.chosen-message .v-list-item__subtitle {
  color: #ffffff;
} */
</style>